import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Graphique en barres — duotone (analytics, statistiques) */
export const ChartBarIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Barre centrale pleine menthe */}
      <rect x="10.5" y="6" width="3.5" height="13.5" rx="1" fill="var(--equiply-icon-bg)" />
      {/* Barre gauche */}
      <rect x="4" y="12" width="3.5" height="7.5" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Barre droite */}
      <rect x="17" y="9" width="3.5" height="10.5" rx="1" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Base */}
      <path d="M3 21h18" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
);
ChartBarIcon.displayName = "ChartBarIcon";
